import React from 'react';

const AboutMePage = () => {
  return (
    <div>
      Under construction
    </div>
  );
};

export default AboutMePage;
